import { Grid, Button, Typography } from "@mui/material";

export function VariableList({ variables, onSelect, theme }) {
  return (
    <Grid container spacing={1.5}>
      {variables.map((v) => (
        <Grid item xs={6} key={v.id}>
          <Button
            fullWidth
            onClick={() => onSelect(v.value)}
            sx={{
              display: "flex",
              flexDirection: "column",
              p: 1,
              borderRadius: "12px",
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "white",
              textTransform: "none",
              "&:hover": {
                borderColor: theme.palette.primary.main,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              },
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.primary.main,
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              {`{{${v.value}}}`}
            </Typography>
          </Button>
        </Grid>
      ))}
    </Grid>
  );
}
